// extracted by mini-css-extract-plugin
export default {"layout":"AppRouter_layout__M8Jno"};